import React, { useState } from "react";
import { Grid } from "@material-ui/core";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
// import { Principal } from "@dfinity/agent";
import { toast } from "react-toastify";
import { useHistory } from "react-router";
import StyledCollectionCard from "./CollectionCard.styled";
import { ReactComponent as MenuIcon } from "../../../assets/icons/actionsMenu.svg";
import Text from "../../atoms/Text";
import { H5 } from "../../atoms/H/H.styled";
import Card from "../../atoms/Card";
import Button from "../../atoms/Button";
import { ICollection } from "../../../store/MarketplaceStore/collections";
// import { MarketApi } from "../../../api";
// import { fetchCollections } from "../../../api/hooks/MarketApi";

interface ICollectionCard {
  item: ICollection;
  handleEditCollection: (item: any) => void;
}

const CollectionCard = ({ item, handleEditCollection }: ICollectionCard) => {
  const [isMenuOpened, setIsMenuOpened] = useState(false);
  const history = useHistory();
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const { symbol, enabled } = item;

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleEnable = async () => {
    // try {
    //   await MarketApi.updateCollection({
    //     ...item,
    //     enabled: !item.enabled,
    //   });
    //   toast.success(`Successfully ${item.enabled ? "disabled" : "enabled"}`);
    //   fetchCollections();
    // } catch (e) {
    //   toast.error(e.message);
    // }
  };

  const edit = () => {
    handleEditCollection(item);
    handleClose();
  };

  return (
    <>
      <Card>
        <StyledCollectionCard>
          <Grid container spacing={3} alignItems="center">
            <Grid item>
              <Text as="span" color={enabled ? "primary" : "grey2"}>
                {enabled ? "Active" : "Disabled"}
              </Text>
            </Grid>
            <Grid item xs>
              <H5 as="span">{symbol}</H5>
            </Grid>
            {/* <Grid item xs> */}
            {/*  <Text as="span">{itemsCount} items</Text> */}
            {/* </Grid> */}
            <Grid item>
              <Button
                onClick={() => history.push("/inventory")}
                small
                outlined
                aria-haspopup="true"
              >
                all items
              </Button>
            </Grid>
            <Grid item style={{ display: "flex" }}>
              <Button
                style={{ padding: "0 6px 0 10px" }}
                textBtn
                small
                onClick={handleClick}
              >
                <MenuIcon />
              </Button>
              <Menu
                anchorEl={anchorEl}
                keepMounted
                open={Boolean(anchorEl)}
                onClose={handleClose}
              >
                <MenuItem onClick={edit}>
                  <Text>Edit</Text>
                </MenuItem>
                <MenuItem onClick={handleEnable}>
                  <Text color={item.enabled ? "error" : "success"}>
                    {item.enabled ? "Disable" : "Enable"}
                  </Text>
                </MenuItem>
              </Menu>
            </Grid>
          </Grid>
        </StyledCollectionCard>
      </Card>
    </>
  );
};

export default CollectionCard;
